import { Box, Center, Paper, Table, Text, Title, createStyles } from "@mantine/core";
import { formatDateTime } from "@medplum/core";
import { StatusBadge, useMedplum } from "@medplum/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CustomTable } from "../../../components/Table";

const useStyles = createStyles((theme) => ({
  table: {
    marginTop: "30px",
  },
  thead: {
    backgroundColor: "#BEDEF8",
    borderRadius: 4,
  },
  box:{
    marginTop:"10px"
  }
}));

export const Appointment = () => {
  const { patientId } = useParams();
  const { classes } = useStyles();
  const medplum = useMedplum();
  const [appointments, setAppointments] = useState<any>([]);
  const tableHeaders = ["Appointment Type", "Type", "Date", "Status"];

  useEffect(() => {
    getAppointment();
  }, [patientId]);

  const getAppointment = async () => {
    const res = await medplum.searchResources(
      "Appointment",
      `patient=Patient/${patientId}`
    );
    setAppointments(res);
  };
  const patientAppointment = appointments?.map((data: any) => ({
    "appointment Type": data.appointmentType?.coding?.[0].display,
    type: data?.serviceType?.[0]?.coding?.[0]?.display,
    Date: formatDateTime(data.created as string),
    Status: data.status as string,
  }));

  return (
    <>
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "0px",
          marginRight: "0px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
        withBorder
      >
        <Title>Appointments</Title>

        <Box className={classes.box}>
          <CustomTable
            showActionColumn={true}
            head={tableHeaders}
            data={patientAppointment}
            handleStartCall={() => {}}
          />
        </Box>
        {appointments?.length === 0 && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Text size="xl" color="dimmed">
              No results
            </Text>
          </Center>
        )}
      </Paper>
    </>
  );
};
